export default {
  get: () => {
    if(process.env.VUE_APP_ENV === "local"){
      return "testbusiness";//"prodashstagingbus";//"testbusiness"; //"testbusiness";//"karamellaSweets"; //testbusiness ; //dalgetyfishbar
    }
    else{
      let full = window.location.host;
      //window.location.host is subdomain.domain.com
      let parts = full.split(".");
      let sub = parts[0];
      return sub;
    }
  },
};
